import once from 'lodash/once';
import PropTypes from 'prop-types';
import IconButton from './IconButton/IconButton';
import Icon from '../../icon';
import trackPdfDownload from '../../../utils/trackers/trackPdfDownload';
import { trackAdobeWidgetImpression } from '../../../utils/trackers/adobe';

const triggerAAeventOnce = once(downloadUrl => trackAdobeWidgetImpression([`save-button${!downloadUrl ? '-not' : ''}-displayed`]));

export default function SaveButton({ downloadUrl }) {
  triggerAAeventOnce(downloadUrl);

  if (!downloadUrl) {
    return null;
  }

  return (
    <div className="save-pdf-button-wrapper">
      <IconButton
        href={downloadUrl}
        id="save-pdf-icon-button"
        onClick={trackPdfDownload}
        icon={Icon.Download}
        title="Download PDF"
        aria-label="Download PDF"
      />
    </div>
  );
}

SaveButton.propTypes = {
  downloadUrl: PropTypes.string,
};

SaveButton.defaultProps = {
  downloadUrl: '',
};
